<div class="chat-layout">
  <div class="conversations-list">
    <app-conversations-list [activeConversationId]="conversationId()"></app-conversations-list>
  </div>

  <div class="chat-box-container">
    <app-chat-box
      class="col col-center"
      (viewProperty)="togglePropertyPanel(true)"
      [swapRequest]="swapRequest()"
      [resolvedMessages]="resolvedMessages()"></app-chat-box>
  </div>

  @if (swapRequest()) {
    <div class="property-details">
      <app-chat-property class="col col-right" [swapRequest]="swapRequest()"></app-chat-property>
    </div>
  }
</div>
<div class="property-panel-modal" *ngIf="isPropertyPanelVisible">
  <div class="modal-overlay" (click)="togglePropertyPanel(false)"></div>
  <div class="modal-content">
    <app-chat-property [swapRequest]="swapRequest()"></app-chat-property>
  </div>
</div>
